import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import React, { useMemo } from 'react'
import { GrupoTrib, Marca, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import moment from 'moment'

type Props = {
    trib: GrupoTrib[],
}

interface RowData {
    id: number,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_delete?: string,
    descricao: string,
}

export const GridTribExcluido = React.memo(({ trib }: Props) => {

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const colunas = useMemo<MRT_ColumnDef<GrupoTrib>[]>(
        () => [

            {
                accessorKey: 'descricao', header: 'Descrição', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.descricao ? <span className='break-all'>{rowData.descricao}</span> : <span className='text-red-400'>N/D</span>)

                }
            },

            {
                accessorKey: 'name_user_delete', header: 'Usuário de Exclusão', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.name_user_delete ? rowData.name_user_delete : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'motivo_exclusao', header: 'Motivo de Exclusão', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.motivo_exclusao ? rowData.motivo_exclusao : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'dh_exclusao', header: 'Data de Exclusão', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.dh_exclusao ? moment(rowData.dh_exclusao).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>)

                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: trib,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

        </>
    )

})